@keyframes fade {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.wrapper {
  position: relative;
  width: 24px;
  height: 24px;
}

.icon {
  position: absolute;
  top: 0;
  left: 0;
  cursor: pointer;
  animation: fade 0.2s ease-in-out;
}

.naviScreen {
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--z-index-mid);
  width: 100%;
  height: calc(100vh - 48px);
  padding-bottom: 120px;
  margin-top: 48px;
  overflow-y: auto;
  background-color: white;
  animation: fade 0.3s ease-in-out;
}
